import styles from './BrandLoader.module.scss';

/**
 * Единый индикатор загрузки MyTeacher. Эталон - прелоадер myteacher.pro (блок «Скоро все будет»):
 * белая карточка с черной обводкой и тенью, красная полоса и три «прыгающих» блока.
 * Один и тот же файл лежит в myteacher.pro и profile.myteacher.pro.
 *  - size='sm' - компактная версия для кнопок и строк;
 *  - size='md' - блоки и списки внутри страниц;
 *  - size='lg' - полноэкранные прелоадеры.
 */
export type BrandLoaderSize = 'sm' | 'md' | 'lg';

export function BrandLoaderMark({ className = '' }: { className?: string }) {
  return (
    <svg
      className={`${styles.mark} ${className}`}
      viewBox='0 0 120 120'
      aria-hidden='true'
      focusable='false'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect className={styles.shadow} x='18' y='22' width='84' height='84' rx='16' />
      <rect className={styles.card} x='14' y='18' width='84' height='84' rx='16' />
      <rect className={`${styles.block} ${styles.block1}`} x='28' y='62' width='18' height='18' rx='4' />
      <rect className={`${styles.block} ${styles.block2}`} x='51' y='62' width='18' height='18' rx='4' />
      <rect className={`${styles.block} ${styles.block3}`} x='74' y='62' width='18' height='18' rx='4' />
      <rect className={styles.accentBar} x='28' y='38' width='56' height='10' rx='3' />
    </svg>
  );
}

type BrandLoaderProps = {
  size?: BrandLoaderSize;
  /** Видимая подпись. Без нее подпись «Загрузка» остается только для скринридеров. */
  label?: string;
  /** Блок на всю ширину по центру (для страниц и списков). */
  center?: boolean;
  className?: string;
};

export function BrandLoader({ size = 'md', label, center = false, className = '' }: BrandLoaderProps) {
  return (
    <span
      className={`${styles.root} ${styles[size]} ${center ? styles.center : ''} ${className}`}
      role='status'
      aria-live='polite'
    >
      <BrandLoaderMark />
      {label ? <span className={styles.label}>{label}</span> : <span className={styles.srOnly}>Загрузка</span>}
    </span>
  );
}

export default BrandLoader;
